import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { AuthService } from '../../services/auth-service'
import * as api from '../../api'
import * as qs from "query-string";

import { Grid, Segment, Popup} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { Helmet } from "react-helmet";
import MeterTableHeader from "./meter-table-header";
import MeterTableRow from "./meter-table-row";
import { collateUtilityData, defaultUtilities, collateMeterCountData } from "../../helpers/chart-dataset-helpers";
import MonthlyUtilityChart from "../../components/charts/custom/monthly-utility-chart";
import YearlyDonutChart from "../../components/charts/custom/yearly-donut-chart";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import MeterReadsUploadModal from "./meter-reads-modal"
import { apiUrl } from "../../config.js"
import axios from 'axios';
import ReactGA from 'react-ga';
import { BreadcrumbContext } from '../../components/header/breadcrumbcontext'; // Adjust the path as necessary

class Meters extends Component {
    static contextType = BreadcrumbContext;

    constructor(props) {
        super(props);

        this.authServices = new AuthService();
        this.stickyRef = React.createRef();
        this.checkSticky = this.checkSticky.bind(this);

        this.state = {
            dataProvider: new ApiDataProvider(api.getCustomerMeters, [this.props.customerId]),
            metersCount: {},
            completenessData: [],
            gasMeterCount: [],
            elecMeterCount: [],
            waterMeterCount: [],
            params: qs.parse(this.props.location.search),
            isReadOnly : this.authServices.isReadOnly(),
            UpdateMe: "ready",
            currentChartClick : "",
            selectedMeterKey: null, // Add this to track the selected meter
            selectedSiteKey : null,
            isSticky: false

        }
    }

    checkSticky = () => {
      
        if (this.stickyRef.current) {
            const stickyTop = this.stickyRef.current.getBoundingClientRect().top;
            const isSticky = stickyTop <= 200; // 70px is the top value in stickyGraphStyle
            if (isSticky !== this.state.isSticky) {
                this.setState({ isSticky, shouldHideSecondRow: isSticky });
            }
        }
    };

    

    setOpen = (open) => {
        if(open === false)
        {
            this.setState({
        
                showInfoHide : false,
                showErrorHide : true,
                showSuccessHide  : true,
            });
        }
        this.setState({
        
            meterModalOpen : open
        });
    }

    downloadDocument = () => {
        this.setState({
        
            downloadingFile : true
        });
        axios({
            url: `${apiUrl}/MeterReads/MeterReadBulkTemplate/${this.props.customerId}`,
            method: 'POST',       // Worked using POST or PUT. Prefer POST
            headers: {
                'Authorization': `bearer ${localStorage.getItem("token")}`
            },
            responseType: 'blob', // important
        }).then((response) => {
            this.setState({
        
                downloadingFile : false
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'meterReadsTemplate.csv');
            document.body.appendChild(link);
            link.click();
        });
    }

    handleChartClick = (e) => {
      
        if (Array.isArray(e) && e.length > 0 && e[0] && '_view' in e[0]) {        

        var label = e[0]._view.label


        let title = e[0]._chart.options.title.text;
        let matches = title.match(/\b(Gas|Electricity|Water)\b/);

        let extractedUtility= matches ? matches[0] : null;


        this.filterableDataTableRef.onAdvancedFilterChange({
            name : "MeterType",
            value: ""
        });

        this.filterableDataTableRef.onAdvancedFilterChange({
            name : "Utility",
            value: ""
        });
      

        this.setState({ //Having to chain these to update the state in the right order. Don't like it need to review. 
            currentChartClick: label, 
            meterTypeOverride: label, 
            //
        }, () => {
          

            this.filterableDataTableRef.onAdvancedFilterChange({
                name : "MeterType",
                value: label
            });
    
            this.filterableDataTableRef.onAdvancedFilterChange({
                name : "Utility",
                value: extractedUtility
            });
            
            this.setState({
                
                supplyOverride: extractedUtility
            }, () => {
                this.filterableDataTableRef.onAdvancedFilterChange({
                    name : "MeterType",
                    value: label
                });
        
                this.filterableDataTableRef.onAdvancedFilterChange({
                    name : "Utility",
                    value: extractedUtility
                });
            }) 

            // After state is updated, then update the filters
          
          
        });


        }else
        {
          
      
        }



    }

 

    updateSupplyOverride = (newSupplyOverride) => {
        this.setState({ supplyOverride: newSupplyOverride }, () => {
          // You can perform additional actions here if needed, such as refreshing data
          //this.fetchData(newSupplyOverride);
        });
      };


    render() {
        const stickyGraphStyle = {
            position: 'sticky',
            top: '50px',
            zIndex: 100,
            backgroundColor: 'white',
            padding: '10px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            display: this.state.isSticky ? 'flex' : 'none' // LG Instructions: Initially hide this Grid.Row
        };
    
        return (
            <div className='main-container'>
                <Helmet>
                    <title>Inenco Portal | Meters</title>
                </Helmet>
                <Grid padded stackable columns='equal'>
                    <Grid.Row>
                    {this.state.params.meterReadMode !== undefined ?
                        <Grid.Column>
                            <h2>Upload meter read for a single meter</h2>
                        </Grid.Column>
                                    : 
                        <Grid.Column>
                            <h2>Meters</h2>
                        </Grid.Column> }
                    </Grid.Row>
                    {this.state.params.meterReadMode !== undefined ?
                            <div>
                                <Segment inverted color='blue'>
                                    To submit your meter reads, please use the available search options to find the meter you require. Once you&apos;ve found it, click to view the meter details and submit your reads. 
                                </Segment>
                            </div>
                        :
<>
                            <Grid.Row style={stickyGraphStyle}>
                                {this.state.selectedMeterKey === null ? (
                                    <>
                                        <Grid.Column width={3}>
                                            {!!this.state.gasMeterCount.length > 0 && 
                                                <YearlyDonutChart data={this.state.gasMeterCount[0]} title={"No. of Gas Meters By Type"} id='Gas'
                                                    onElementsClick={(e) => this.handleChartClick(e)}  size={"compress"}
                                                    

                                                />
                                            }
                                        </Grid.Column>
                                        <Grid.Column width={3}>
                                            {!!this.state.elecMeterCount.length > 0 && 
                                                <YearlyDonutChart data={this.state.elecMeterCount[0]} title={"No. of Electricity Meters By Type"} id='Electricity'
                                                    onElementsClick={(e) => this.handleChartClick(e)}  size={"compress"}

                                                />
                                            }
                                        </Grid.Column>
                                        <Grid.Column width={3}>
                                            {!!this.state.waterMeterCount.length > 0 && 
                                                <YearlyDonutChart data={this.state.waterMeterCount[0]} title={"No. of Water Meters By Type"} id='Water'
                                                    onElementsClick={(e) => this.handleChartClick(e)}  size={"compress"}

                                                />
                                            }
                                        </Grid.Column>
                                    </>
                                ) : null}
                                <Popup content='PLEASE NOTE -  this graph is created based on calculations for expected dates of invoice delivery to Inenco and upload to our database. Therefore the graph/s may not show the full last 12 months of data-completeness. (e.g. a series line with quarterly supplier billing may be “missing” up to 3 months backwards from today’s date – this will still be deemed to be 100% data-complete).' 
                                    position='left center' 
                                    inverted 
                                    trigger={
                                        <Grid.Column width={this.state.selectedMeterKey === null ? 7 : 16}>
                                            {!!this.state.completenessData.length > 0 &&
                                                <MonthlyUtilityChart data={this.state.completenessData} label={"Percentage Complete (%)"}  size={"compress"}
                                                    title={"Monthly Data Completeness"} />
                                            }
                                        </Grid.Column>
                                    }
                                />
                            </Grid.Row>

                            {!this.state.isSticky && ( <>

                            <Grid.Row>
                                {this.state.selectedMeterKey === null ? (
                                    <>
                                        <Grid.Column width={3}>
                                            {!!this.state.gasMeterCount.length > 0 && 
                                                <YearlyDonutChart data={this.state.gasMeterCount[0]} title={"No. of Gas Meters By Type"} id='Gas'
                                                    onElementsClick={(e) => this.handleChartClick(e)}
                                                    

                                                />
                                            }
                                        </Grid.Column>
                                        <Grid.Column width={3}>
                                            {!!this.state.elecMeterCount.length > 0 && 
                                                <YearlyDonutChart data={this.state.elecMeterCount[0]} title={"No. of Electricity Meters By Type"} id='Electricity'
                                                    onElementsClick={(e) => this.handleChartClick(e)}

                                                />
                                            }
                                        </Grid.Column>
                                        <Grid.Column width={3}>
                                            {!!this.state.waterMeterCount.length > 0 && 
                                                <YearlyDonutChart data={this.state.waterMeterCount[0]} title={"No. of Water Meters By Type"} id='Water'
                                                    onElementsClick={(e) => this.handleChartClick(e)}

                                                />
                                            }
                                        </Grid.Column>
                                    </>
                                ) : null}
                                <Popup content='PLEASE NOTE -  this graph is created based on calculations for expected dates of invoice delivery to Inenco and upload to our database. Therefore the graph/s may not show the full last 12 months of data-completeness. (e.g. a series line with quarterly supplier billing may be “missing” up to 3 months backwards from today’s date – this will still be deemed to be 100% data-complete).' 
                                    position='left center' 
                                    inverted 
                                    trigger={
                                        <Grid.Column width={this.state.selectedMeterKey === null ? 7 : 16}>
                                            {!!this.state.completenessData.length > 0 &&
                                                <MonthlyUtilityChart data={this.state.completenessData} label={"Percentage Complete (%)"}
                                                    title={"Monthly Data Completeness"} />
                                            }
                                        </Grid.Column>
                                    }
                                />
                            </Grid.Row>
                           
                            </>)}
                            </>
                    }

                    <Grid.Row>
                        <Grid.Column>
                            <h2>Meter List</h2>
                        </Grid.Column>
                        {this.state.params.meterReadMode === undefined &&
                        <Grid.Column>

                  
                        {this.state.isReadOnly === false &&
                            <MeterReadsUploadModal customerId={this.props.customerId}></MeterReadsUploadModal>
                        }
                        </Grid.Column>
                        }
                    </Grid.Row>
                    <Grid.Row>
                    <Grid.Column>
                    <Grid.Column>
                    </Grid.Column>
                    <div ref={this.stickyRef}  className="table-container">
                        <FilterableDatatable dataProvider={this.state.dataProvider} name="meters" canExport={true} 
                        storeName="meterList" //clearStore={this.getStoreageRule()}
                        ref={(ref) => (this.filterableDataTableRef = ref)}  

                            contextData={{ customerId: this.props.customerId
                              
                            
                            }} 
                            
                            
                            defaultSort={"id"}
                            headerComponent={MeterTableHeader} //rowComponent={MeterTableRow}

                            rowComponent={(props) => <MeterTableRow {...props} 
                            selected={this.state.selectedMeterKey === props.data.meterSiteKey} 
                            onRowSelect={this.handleRowSelect} />} 

                            supplyOverride={this.state.supplyOverride}

                            meterTypeOverride={this.state.meterTypeOverride}

                           
        
            
            />
    </div>
                        </Grid.Column>
                      
                    </Grid.Row>
                </Grid>
            </div>
        );
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.checkSticky);
     }
     
    componentDidMount = () => {
        ReactGA.pageview('meters');
        this.context.addBreadcrumb({ title: "Meters" , path: '/Meters' });
        window.addEventListener('scroll', this.checkSticky);
        setTimeout(this.checkSticky, 100); // Delay to ensure the component is fully rendered

        if(this.state.params.meterReadMode !== undefined)
        {
        }else 
        {
        }

        // this.props.history.listen(() => {
        //     // Detecting, user has changed URL
        //     console.info(this.props.history.location.pathname);

        //     window.history.replaceState(null, '') //Allows back button to work on stored Searches
        // });

        this.fetchData();
    }

    resetData = () => {
        this.fetchData(); // Assuming fetchData() loads default graph data
      };


    getStoreageRule() {
        try {
           
            return this.props.location.state.clearStore; // better way to check undefined but i'm going mad today
        } catch
        {
            return false
        }
    }

    handleRowSelect = (siteKey, meterKey) => {
        this.setState(prevState => ({
            selectedMeterKey: prevState.selectedMeterKey === meterKey ? null : meterKey
        }), () => {
            if (this.state.selectedMeterKey === null) {
                this.resetData();
            } else {
                this.fetchDataForMeter(siteKey, meterKey);
            }
        });
    };
    

    fetchDataForMeter = (siteKey, MeterKey) => {
        return Promise.all([
            //api.getMetersCount(this.props.customerId),
            api.getMeterConsumption(this.props.customerId, siteKey, MeterKey)
        ])
            .then(([consumptionData]) => {
             

                this.setState({
                   // gasMeterCount: collateMeterCountData(metersCount, "Gas"),
                    //waterMeterCount: collateMeterCountData(metersCount, "Water"),

                   // elecMeterCount: collateMeterCountData(metersCount, "Electricity"),
                    completenessData: collateUtilityData(consumptionData, "dataCompleteness", defaultUtilities, x => (x * 100).toFixed(2))
                });
            });
      };

    fetchData = () => {
        return Promise.all([
            api.getMetersCount(this.props.customerId),
            api.getMonthlyCostConsumption(this.props.customerId)
        ])
            .then(([metersCount, consumptionData]) => {

               

                this.setState({
                    gasMeterCount: collateMeterCountData(metersCount, "Gas"),
                    waterMeterCount: collateMeterCountData(metersCount, "Water"),

                    elecMeterCount: collateMeterCountData(metersCount, "Electricity"),
                    completenessData: collateUtilityData(consumptionData, "dataCompleteness", defaultUtilities, x => (x * 100).toFixed(2))
                });
            });
    }
}

export default withRouter(Meters)